import {MOBILE_BREAKPOINT} from '../constants';
import {useWindowDimensions} from '../hooks/useWindowDimensions';

export const mobiles = (style: string) => `
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    ${style}
  }
`;

export const useIsMobile = () => {
  const {width} = useWindowDimensions();
  return width < MOBILE_BREAKPOINT;
};
